import { apiClient } from "@/lib/api";
import type { Translations } from "@/types";
import type { SupportedLocale } from "@/lib/locales";

export type AutoTranslateCatalogFieldsRequest = {
  source_language: SupportedLocale;
  target_languages: readonly SupportedLocale[];
  name: string;
  description: string;
};

export type AutoTranslateCatalogFieldsResponse = {
  name_translations: Translations;
  description_translations: Translations | null;
};

export const catalogTranslationService = {
  translateCatalogFields: async (
    activityId: string,
    data: AutoTranslateCatalogFieldsRequest,
  ): Promise<AutoTranslateCatalogFieldsResponse> => {
    const response = await apiClient.post<AutoTranslateCatalogFieldsResponse>(
      `/catalog/translations/activities/${activityId}/translate`,
      data,
    );
    return response.data;
  },

  translateCatalogFieldsDraft: async (
    data: AutoTranslateCatalogFieldsRequest,
  ): Promise<AutoTranslateCatalogFieldsResponse> => {
    const response = await apiClient.post<AutoTranslateCatalogFieldsResponse>(
      "/catalog/translations/translate",
      data,
    );
    return response.data;
  },

  translateCatalogFieldsForContext: async (
    activityId: string | undefined,
    data: AutoTranslateCatalogFieldsRequest,
  ): Promise<AutoTranslateCatalogFieldsResponse> => {
    if (activityId) {
      return catalogTranslationService.translateCatalogFields(activityId, data);
    }
    return catalogTranslationService.translateCatalogFieldsDraft(data);
  },
};
